import React from 'react';
import 'devextreme-react/text-area';
import Form, { Item } from 'devextreme-react/form';
import './style.scss';

const employeeData = {
  ID: 1,
  FirstName: 'John',
  LastName: 'Heart',
  Position: 'CEO',
  BirthDate: '1964/03/16',
  HireDate: '1995/01/15',
  Notes: 'John has been in the Audio/Video industry since 1990. He has led DevAv as its CEO since 2003.\r\n\r\nWhen not working hard as the CEO, John loves to golf and bowl. He once bowled a perfect game of 300.',
  Address: '351 S Hill St., Los Angeles, CA',
  Phone: '360-684-1334',
  Email: 'jheart@dx-email.com',
};

const positionsData = [
  'HR Manager',
  'IT Manager',
  'CEO',
  'Controller',
  'Sales Manager',
  'Support Manager',
  'Shipping Manager',
];

export default function Forms() {
  const employee = employeeData;
  const positions = positionsData;
  const rules = { X: /[02-9]/ };

  const validationRules = {
    position: [
      { type: 'required', message: 'Position is required.' },
    ],
    hireDate: [
      { type: 'required', message: 'Hire Date is required.' },
    ],
  };

  const nameEditorOptions = { disabled: false };
  const positionEditorOptions = { items: positions, searchEnabled: true, value: '' };
  const hireDateEditorOptions = { width: '100%', value: null };
  const birthDateEditorOptions = { width: '100%', disabled: true };
  const notesEditorOptions = { height: 90 };
  const phonesEditorOptions = { mask: '+1 (X00) 000-0000', maskRules: rules };

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <div className="form-container">
      <Form
        onContentReady={validateForm}
        colCount={2}
        id="form"
        formData={employee}
      >
        <Item dataField="FirstName" editorOptions={nameEditorOptions} cssClass={'max-width-440'} />
        <Item dataField="Position" editorType="dxSelectBox" editorOptions={positionEditorOptions} validationRules={validationRules.position} cssClass={'max-width-440'} />
        <Item dataField="LastName" editorOptions={nameEditorOptions} cssClass={'max-width-440'} />
        <Item dataField="HireDate" editorType="dxDateBox" editorOptions={hireDateEditorOptions} validationRules={validationRules.hireDate} cssClass={'max-width-440'} />
        <Item dataField="BirthDate" editorType="dxDateBox" editorOptions={birthDateEditorOptions} cssClass={'max-width-440'} />
        <Item dataField="Address" cssClass={'max-width-440'} />
        <Item dataField="Phone" editorOptions={phonesEditorOptions} cssClass={'max-width-440'} />
        <Item dataField="Email" cssClass={'max-width-440'} />
        <Item dataField="Notes" colSpan={2} editorType="dxTextArea" editorOptions={notesEditorOptions} cssClass={'max-width-440'} />
      </Form>
    </div>
)}
